import { saveAs } from 'file-saver';

export async function saveFileAsPdf(encodedPdf: string, filename: string) {
  const response = await fetch(`data:application/pdf;base64,${encodedPdf}`);
  const pdfBlob = await response.blob();

  const fileNameWithExtension = `${filename}.pdf`;

  return saveAs(pdfBlob, fileNameWithExtension);
}
